const RateTableHomeTypeList = [
    { text: 'Single Family', value: '1' },
    { text: 'Town House', value: '2' },
    { text: 'Condo', value: '3' },
    { text: 'Multifamily', value: '5' },
    { text: 'Co-op', value: '6' },
];

export default RateTableHomeTypeList;
